import './App.css'

import React from 'react';

import Header from './components/Header/header.js'
import Main from './components/Main/main.js'



export default function App() {
  return (
    <div className="App">

      <Header/>
      <Main/>
    </div>
  );
}
